import React, { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { TouchableOpacity, View } from 'react-native'
import { useNavigation } from '@react-navigation/native'

import {
  ProjectBackIcon,
  ProjectTrendingDown,
  ProjectTrendingUp,
} from '../../../../../assets/icons'
import { paths } from '../../../../links'
import { ProjectTileCard } from '../ProjectTileCard'
import { BtTab, BtTabs, BtText } from '@linqpal/components/src/ui'
import { ViewProjectSidebar } from '../../Sidebar/ViewProjectSidebar'
import { Expenses, Income, Payables, Receivables } from './Tabs'

import { styles } from './styles'

import projectsStore from '../../../Store'
import chosenProjectStore, { Sidebar } from '../../../Store/ChosenProject'
import { ViewInvoiceSidebar } from '../../Sidebar/ViewInvoice'
import { currencyMask } from '../../../../../utils/helpers/masking'

type ProjectDetailProps = {
  projectId: string
  pageData: any
}

export const ProjectsDetailContent = observer(
  ({ pageData }: ProjectDetailProps) => {
    const navigation = useNavigation()

    const { t } = useTranslation('global')

    const { stats } = pageData
    const { projectDetail, resetEverything, resetRefresher } = projectsStore
    const { setIsOpenedSidebar } = chosenProjectStore

    const chosenProject = useMemo(() => projectDetail, [projectDetail])
    const name =
      projectDetail?.data?.propertyAddress?.items[0]?.content?.streetAddress

    return (
      <View style={styles.mainWrapper}>
        <TouchableOpacity
          testID="projects-detail-back"
          onPress={() => {
            resetEverything()
            resetRefresher()
            navigation.navigate(paths.Console.Projects.List)
          }}
        >
          <View style={styles.backBtnContainer}>
            <ProjectBackIcon />
            <BtText style={styles.backBtnText}>
              {t('Projects.BackToProjects')}
            </BtText>
          </View>
        </TouchableOpacity>

        <BtText style={styles.backBtnTextTitle}>{name}</BtText>

        <TouchableOpacity
          testID="projects-detail-view-sidebar"
          onPress={() => {
            setIsOpenedSidebar(true, Sidebar.VIEW)
          }}
        >
          <BtText style={styles.projectViewDetailBtnText}>
            {t('Projects.ViewDetail')}
          </BtText>
        </TouchableOpacity>

        <View style={styles.projectTileContainer}>
          <ProjectTileCard
            testID="projects-detail-outstanding-receivables"
            icon={null}
            title={t('Projects.OutstandingReceivables')}
            value={currencyMask(stats?.receivables)}
          />

          <ProjectTileCard
            testID="projects-detail-income"
            title={t('Projects.Income')}
            icon={<ProjectTrendingUp />}
            value={currencyMask(stats?.income)}
          />

          <ProjectTileCard
            testID="projects-detail-expenses"
            title={t('Projects.Expense')}
            icon={<ProjectTrendingDown />}
            value={currencyMask(stats?.expense)}
          />
        </View>

        <>
          <BtText style={styles.projectTabsTitleText}>
            {t('Projects.InvoicesNSalesOrders')}
          </BtText>

          <View style={styles.mt24}>
            <BtTabs>
              <BtTab
                label={t('Menu.Receivables')}
                style={styles.projectTabLabel}
              >
                <Receivables />
              </BtTab>

              <BtTab label={t('Projects.Income')}>
                <Income />
              </BtTab>

              <BtTab label={t('payables')}>
                <Payables />
              </BtTab>

              <BtTab label={t('Projects.Expenses')}>
                <Expenses />
              </BtTab>
            </BtTabs>
          </View>

          <ViewProjectSidebar chosenProject={chosenProject} />

          <ViewInvoiceSidebar />
        </>
      </View>
    )
  },
)
